import { customLoginAxios, customLoginFileAxios } from "./customAxios";

/**
 * 업체 기존 정보 목록
 * @returns 
 */
export const getCompanyInfoAll = async()=>{
  const res = await customLoginAxios.get('/api/public/join/companies/info');
  if (res.data) {
    return res.data;
  }
  return null;
}


/**
 * 사용자 ID 중복확인
 * @param {*} query 
 * @returns 
 */
export const getCheckDupleLoginId = async(query)=>{
  const res = await customLoginAxios.get('/api/public/join/checkDupLoginId',{params : query});
  if (res.data) {
    return res.data;
  }
  return false;
}

/**
 * 사용자 이메일 중복확인
 * @param {*} query 
 * @returns 
 */
export const getCheckDupleEmail = async(query)=>{
  const res = await customLoginAxios.get('/api/public/join/checkDupEmail',{params : query});
  if (res.data) {
    return res.data;
  }
  return false;
}

/**
 * 업체&사용자 등록
 * @param {*} body 
 */
export const postCompanyAndUsers = async(formData)=>{
  //console.log(body);
  await customLoginFileAxios.post('/api/public/join',formData);
}